export const StopVideo = function ($video) {
	const video = $video.get(0);

	if (video) {
		PauseVideo($video);
		video.currentTime = 0;
	}
};

export const PauseVideo = function ($video) {
	const video = $video.get(0);

	if (video) {
		if (isPlaying($video)) {
			video.pause();
			//video.removeAttribute("controls");
		}
	}
};

export const isPlaying = function ($video) {
	const video = $video.get(0);

	if (video) {
		let isPlaying = video.currentTime > 0 && !video.paused && !video.ended && video.readyState > 2;

		return isPlaying;
	}
};

export const isPaused = function ($video) {
	const video = $video.get(0);

	return video.paused;
};

export const SetVideoSrc = function ($videoSource, dataSource) {
	if ($videoSource) {
		let currentSource = $videoSource.attr('src'),
			newSource = dataSource;

		if (newSource !== currentSource) {
			$videoSource.attr('src', newSource);
		}
	}
};

export const isNewVideo = function ($videoSource, dataSource) {
	if ($videoSource) {
		let currentSource = $videoSource.attr('src'),
			newSource = dataSource;

		if (newSource !== currentSource) {
			return true;
		}
	}

	return false;
};

export const LoadVideo = function ($video) {
	const video = $video.get(0);

	if (video) {
		video.load();
	}
};

export const PlayVideo = function ($video) {
	const video = $video.get(0);

	if (video) {
		let isPlaying = video.currentTime > 0 && !video.paused && !video.ended && video.readyState > 2;

		if (!isPlaying) {
			video.play();
			video.setAttribute("controls","controls");
		}
	}
};

var heroBannerVideo = $('.ndb-hero-video');
var body = $('body');

if(heroBannerVideo.length > 0) {
	var heroBannerVideoWrapper = $('.ndb-video-wrapper');
	var heroBannerVideoCtaWrapper = $('.ndb-video-play-wrapper');
	var heroBannerVideoCta = $('.ndb-video-play');
  var heroBannerVideoClose = $('.ndb-hero-video-close');

	heroBannerVideoCtaWrapper.click(function() {
    heroBannerVideoWrapper.fadeIn();
		body.addClass('modal-active');
	});

	heroBannerVideoCta.click(function() {
    heroBannerVideoWrapper.fadeIn();
		body.addClass('modal-active');
	});

	heroBannerVideoClose.click(function() {
    heroBannerVideoWrapper.fadeOut();
		body.removeClass('modal-active');
	});

}
